<template>
<div class="pb-2">
  <div
    class="profile-pic-sheet"
    :style="{ backgroundImage: `url(${source})`}"
    >
  </div>
  <div class="profile-active" v-if="accountActive"></div>
</div>
</template>

<script>
export default {
  props: ['source', 'accountActive'],
};
</script>

<style lang="scss" scoped>
@import '@/styles/blue-ring.scss';

.profile-active {
  width: 158px;
  height: 158px;
  top: 61px;
  left: 11px;
  border-radius: 50%;
  position: absolute;
  border: 3px solid #4575bc;
  box-shadow: 0 0 8px #4575bc;
}

.profile-pic-sheet {
  position: relative;
  width: 150px;
  height: 150px;
  background-size: cover;
  // margin: auto;
  background-position: top;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid #e7e7e7;
}


</style>
